module.exports = __webpack_public_path__ + "static/media/doctor_icon.7c464288.png";